// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"cbb070d2","952":"62ecfa9c"}[chunkId] + ".chunk.js";
};